
import React from 'react';
import { cn } from '@/lib/utils';
import * as Collapsible from '@radix-ui/react-collapsible';

interface SidebarGroupProps extends React.ComponentPropsWithoutRef<typeof Collapsible.Root> {
  children: React.ReactNode;
  className?: string;
}

export const SidebarGroup = React.forwardRef<
  React.ElementRef<typeof Collapsible.Root>,
  SidebarGroupProps
>(({ className, children, ...props }, ref) => (
  <Collapsible.Root ref={ref} className={cn('py-1', className)} {...props}>
    {children}
  </Collapsible.Root>
));
SidebarGroup.displayName = 'SidebarGroup';


export const SidebarGroupTrigger = Collapsible.Trigger;
SidebarGroupTrigger.displayName = 'SidebarGroupTrigger';

export const SidebarGroupContent = React.forwardRef<
  React.ElementRef<typeof Collapsible.Content>,
  React.ComponentPropsWithoutRef<typeof Collapsible.Content>
>(({ className, children, ...props }, ref) => (
  <Collapsible.Content
    ref={ref}
    className={cn('overflow-hidden transition-all data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down', className)}
    {...props}
  >
    {children}
  </Collapsible.Content>
));
SidebarGroupContent.displayName = 'SidebarGroupContent';

